import { render, staticRenderFns } from "./PlanningPermission.vue?vue&type=template&id=79732708&"
import script from "./PlanningPermission.vue?vue&type=script&lang=ts&"
export * from "./PlanningPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports